import { redirectAndReloadPage } from '../services/sentryReport';

export const triggerCrashReportEvent = (errorData = null) => {
  const event = new CustomEvent('openCrashReport', {
    detail: errorData
  });
  window.dispatchEvent(event);
};

export const openCrashReportFromUtils = (errorData = null) => {
  try {
    triggerCrashReportEvent(errorData);
  } catch (error) {
    console.error('Error during custom crash report :', error);

    // Fallback
    if (window.Sentry) {
      window.Sentry.showReportDialog({
        eventId: errorData.eventId,
        onClose() { redirectAndReloadPage() }
      });
    }
  }
};

export default {
  triggerCrashReportEvent,
  openCrashReportFromUtils
};